import { Navigate } from "react-router-dom";
import { useOwnerSession } from "@/hooks/useOwnerSession";

/**
 * Wrappt alle Unternehmer-Routen. Ohne gültige Owner-Session → Redirect
 * auf /unternehmer/login. Bootstrap (Cookie-Validierung gegen /auth/owner/me)
 * zeigt eine schmale Ladeanzeige, damit das Frontend nicht kurz flackert.
 *
 * AUTH-SICHERHEIT V2 · Phase 2 (Feb 2026): Session-Marker ist ab jetzt
 * `session.tenant_id` (Metadaten-Feld), nicht mehr `session.token` — der
 * Auth-Token liegt im httpOnly-Cookie. Preview-Sessions (tenant_id ===
 * "public-preview") sind zulässig und werden nicht abgewiesen; der
 * Renderer-Level entscheidet, was innerhalb einer Preview sichtbar ist.
 */
export default function ProtectedOwnerRoute({ children }) {
  const { session, loading } = useOwnerSession();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-500 text-sm">
        Lade…
      </div>
    );
  }
  if (!session?.tenant_id) {
    return <Navigate to="/unternehmer/login" replace />;
  }
  return children;
}
